import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { Spacer } from "@qivia/ui";
import { ButtonDS } from "@qivia/ui/src/designSystem/components/Button";
import { Page } from "../../components/Page";
import { RestitutionSummaryContent } from "../shared/restitutionSummaryContent";
import "../../../i18n/i18n";

interface RestitutionCorrectionSummaryStepProps {
  mileage: number;
  isCabinCleaned: boolean;
  isTrunkCleaned: boolean;
  observations: string;
  oldPictures: { uuid: string; url: string }[];
  newPictures: File[];
  onReturn: () => void;
  onValidate: () => void;
  onEdit: () => void;
}

export const RestitutionCorrectionSummaryStep = (
  props: RestitutionCorrectionSummaryStepProps,
) => {
  const { t } = useTranslation();

  return (
    <Page
      title={t("restitution.validation.title")}
      returnButton
      returnButtonAction={props.onReturn}
      withoutHeaderSpacer
      helpButton
      bottomButtonBackgroundColor="white"
      withShadow
      bottomButton={
        <StyledButtons>
          <ButtonDS
            text={t("restitution.button.validateCorrection")}
            buttonType="primary"
            format="fill"
            onClick={props.onValidate}
          />
          <Spacer y={0.5} />
          <ButtonDS
            text={t("restitution.button.edit")}
            buttonType="secondary"
            format="fill"
            onClick={props.onEdit}
          />
        </StyledButtons>
      }
    >
      <StyledForm>
        <Spacer y={1} />
        <RestitutionSummaryContent
          mileage={props.mileage}
          isCabinCleaned={props.isCabinCleaned}
          isTrunkCleaned={props.isTrunkCleaned}
          observations={props.observations}
          oldPictures={props.oldPictures}
          newPictures={props.newPictures}
        />
      </StyledForm>
    </Page>
  );
};

const StyledButtons = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

const StyledForm = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;
